var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBoat = function SvgBoat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 240 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.346 39.497h42.88v-.864h-42.88v.864ZM170.605 55.628h25.643l-5.99-10.052h-19.653v10.052Z",
    fill: "#B3BDC6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M190.258 45.576h-3.263l5.307 9.852h3.826l-5.87-9.852ZM226.794 77.796V88H81.126a86.298 86.298 0 0 1-16.728-1.617C29.476 79.483 7.34 66.882 0 47.686l147.012-1.597 79.782 22.96v8.747Z",
    fill: "#305272"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.126 88h145.668v-8.625H81.126a86.29 86.29 0 0 1-16.728-1.617C34.97 71.944 14.626 62.081 4.558 47.636L0 47.686c.266.693.55 1.378.854 2.055 8.104 18.044 29.883 29.992 63.544 36.642A86.298 86.298 0 0 0 81.126 88Z",
    fill: "#27435D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m118.15 44.922 48.426-42.75-1.132-1.273-48.428 42.75 1.134 1.273Z",
    fill: "#B3BDC6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M183.427 88h43.367v-5.102h-28.729L183.427 88Z",
    fill: "#17324B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M162.651 2.314a2.32 2.32 0 0 0 2.325 2.315 2.319 2.319 0 0 0 2.323-2.315A2.319 2.319 0 0 0 164.976 0a2.32 2.32 0 0 0-2.325 2.314ZM180.558 49.238l-.971.479-20.73-41.679.97-.48 20.731 41.68ZM170.872 46.11l-.971.478-16.747-33.67.97-.479 16.748 33.67Z",
    fill: "#B3BDC6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m173.118 77.796 53.676-.269v-3.376c-2.015-1.2-4.662-2.632-7.968-4.146h-61.115l-.409-.168c5.253 2.222 10.584 4.851 15.816 7.959Zm-18.554-9.085-.461-.19h59.94c-9.671-2.909-21.886-6.207-36.339-9.374-12.258-.678-65.116-1.166-71.355-1.395.281.01 22.98.89 48.215 10.96Zm-48.215-10.96h-.001.001Zm-.001 0h-.001.001Z",
    fill: "#3BB7B6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m219.841 69.413-62.13.598c5.712 2.383 10.641 5.058 15.407 7.785L240 77.46l-20.159-8.048Z",
    fill: "#17324B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M157.711 70.005h63.227v-1.483h-66.835l3.608 1.483Z",
    fill: "#E6F3FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M198.065 62.307h-63.313L3.033 53.905C1.725 51.77.75 49.639 0 47.685c47.37-3.784 94.581-3.711 141.644 0l56.421 14.622Z",
    fill: "#4C6C89"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M133.609 62.307h65.197v-1.484h-87.339l22.142 1.484Z",
    fill: "#E6F3FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M240 77.46S142.621 36.129 0 47.687a18.244 18.244 0 0 1 12.274-5.605l135.836-6.806 69.901 27.578h9.15L240 77.461Z",
    fill: "#ADBDCC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04 45.36h6.587v-1.215H9.04v1.215ZM227.154 70.28h.143v-5.088h-1.006v4.815l.863.272ZM225.514 69.76v-4.568h-1.007v4.25l1.007.319ZM223.729 69.197v-4.005h-1.007v3.688l1.007.317ZM221.945 68.635v-3.443h-1.006v3.124l1.006.319Z",
    fill: "#305272"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m42.718 40.556 124.915 2.383-19.523-8.24-84.297 3.125-21.095 2.732Z",
    fill: "#F3F3F3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m65.706 37.386 21.672-14.742c22.083 3.137 39.554 7.21 56.798 12.148l-50.733 2.594H65.706Z",
    fill: "#CADFF3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M87.378 22.644c6.825.671 14.219 1.88 20.743 3.154C129.929 30.06 148.11 34.7 148.11 34.7l-53.076 3.636-30.451-.512 22.795-15.18Zm.376 1.503L69.287 36.445l25.71.432 43.611-2.987c-7.39-1.745-18.545-4.272-30.769-6.662-5.082-.993-12.641-2.322-20.085-3.08Z",
    fill: "#305272"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M104.798 26.836 91.942 38.152l-1.115-1.256 12.856-11.317M96.155 24.865 81.249 38.16l-1.141-1.268 14.906-13.294",
    fill: "#305272"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m191.443 50.197-.574.282-1.783-3.585.574-.283 1.783 3.586ZM131.945 39.863h12.565V38.71h-12.565v1.154ZM146.768 39.286c0 .638.519 1.154 1.16 1.154.64 0 1.158-.516 1.158-1.154 0-.638-.518-1.155-1.158-1.155-.641 0-1.16.517-1.16 1.155ZM30.875 41.669h.428v-2.604h-.428v2.604ZM34.876 41.669h.428v-2.604h-.428v2.604ZM38.876 41.669h.426v-2.604h-.426v2.604ZM42.876 41.669h.427v-2.604h-.427v2.604ZM27.034 41.669h.426v-2.604h-.427v2.604ZM23.191 41.669h.427v-2.604h-.427v2.604ZM19.348 42.263h.427v-3.198h-.427v3.198ZM15.505 42.263h.427v-3.198h-.427v3.198Z",
    fill: "#B3BDC6"
  })));
};

export { SvgBoat as ReactComponent };
export default __webpack_public_path__ + "static/media/boat.67ee6876.svg";